import { render, staticRenderFns } from "./RealityTime.vue?vue&type=template&id=685888c4&scoped=true"
import script from "./RealityTime.vue?vue&type=script&lang=js"
export * from "./RealityTime.vue?vue&type=script&lang=js"
import style0 from "./RealityTime.vue?vue&type=style&index=0&id=685888c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685888c4",
  null
  
)

export default component.exports